import {
  deletePackageById,
  getPackagesByGroupId,
} from "../../../../Redux/Groups/GroupsActions";
import ConfirmationModal from "../../../Common/ConfirmationModal/ConfirmationModal";
import { AppDispatch, RootState } from "../../../../Redux/store";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import EditPackage from "../../Groups/EditPackage/EditPackage";
import AddPackage from "../../Groups/AddPackage/AddPackage";
import { ICellRendererParams } from "ag-grid-community";
import toastHelper from "../../../../Util/toastHelper";
import { useDispatch, useSelector } from "react-redux";
import { GridReadyEvent } from "ag-grid-community";
import React, { useEffect, useState } from "react";
import Modal from "../../../Common/Modal/Modal";
import { HiDotsVertical } from "react-icons/hi";
import styles from "./Packages.module.scss";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { useNavigate } from "react-router";

interface PackageRate {
  id: number;
  packageId: number;
  noofDays: number;
  period: string;
  rates: number;
  discountRate: number;
  isActive: boolean;
  createdAt: string;
  modifiedAt: string | null;
}

interface Amenity {
  amenityId: number;
  id: number;
  name: string;
  status: string;
  rule: string;
  rates: number;
  image: string;
  lockId: string;
  requiresBooking: boolean;
}
interface PackagesType {
  packageId: number;
  packageName: string;
  description: string;
  status: string;
  expiresAt: string;
  createdAt: string;
  price: number;
  packageRates: PackageRate[];
  amenities: Amenity[];
  isFreeMonth: boolean;
  trialdays: number;
  groupId: number;
  isFamily: boolean;
  noofMember: number;
  discountRate: number;
  isNonMember: boolean;
  isMember: boolean;
}

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

interface Props {
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  groupId: string;
}

function Packages(props: Props) {
  const { setActiveTab, groupId } = props;
  const navigate = useNavigate();
  const [rowData, setRowData] = useState<PackagesType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [addPackage, setAddPackage] = useState(false);
  const [editPackage, setEditPackage] = useState(false);
  const [packageData, setPackageData] = useState<any>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deletePackageId, setDeletePackageId] = useState<number>(-1);
  const { getPackagesByGroupIdData, deletePackageByIdLoading } = useSelector(
    (state: RootState) => state.groups,
  );
  const dispatch = useDispatch<AppDispatch>();
  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  const columnDefs: ColDef<PackagesType>[] = [
    {
      headerName: "Package Name",
      field: "packageName",
      flex: 1,
      minWidth: 150,
    },

    {
      headerName: "Description",
      field: "description",
      flex: 1,
      minWidth: 300,
    },

    {
      headerName: "Amenities",
      field: "amenities",
      flex: 1,
      minWidth: 250,
      valueGetter: (params) => {
        return params?.data?.amenities
          ?.map((item: any) => item.name)
          .join(", ");
      },
    },

    {
      headerName: "Package Duration",
      field: "packageRates",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return params?.data?.packageRates
          ?.map(
            (item: PackageRate) =>
              item?.period?.toLowerCase().charAt(0).toUpperCase() +
              item?.period?.toLowerCase().slice(1),
          )
          .join(", ");
      },
    },

    {
      headerName: "Status",
      field: "status",
      flex: 1,
      maxWidth: 100,
      cellClass: (params) => {
        return params?.data?.status === "Active"
          ? "CompletedText"
          : params?.data?.status === "Expired"
            ? "pendingText"
            : "text-black-500";
      },
    },

    {
      colId: "actions",
      sortable: false,
      suppressAutoSize: true,
      suppressMovable: true,
      suppressNavigable: true,
      editable: false,
      cellStyle: {
        pointerEvents: "all",
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      },
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <div className={styles.iconContainer}>
            <Menu
              direction="left"
              menuButton={
                <MenuButton>
                  <HiDotsVertical className={styles.icon} />
                </MenuButton>
              }
              transition
              portal
            >
              <MenuItem
                onClick={() => {
                  setEditPackage(true);
                  setPackageData(params?.data);
                }}
              >
                Edit
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setIsDeleteModalOpen(true);
                  setDeletePackageId(params?.data?.packageId);
                }}
              >
                Delete
              </MenuItem>
            </Menu>
          </div>
        );
      },
    } as ColDef<PackagesType>,
  ];

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    if (getPackagesByGroupIdData) {
      setRowData(getPackagesByGroupIdData);
    }
  }, [getPackagesByGroupIdData]);

  const nextHandler = () => {
    if (
      Array.isArray(getPackagesByGroupIdData) &&
      getPackagesByGroupIdData?.length > 0
    ) {
      navigate("/admin/groups", {
        replace: true,
      });
    } else {
      toastHelper.error("Please add at least one package");
    }
  };

  useEffect(() => {
    if (groupId) {
      dispatch(
        getPackagesByGroupId({
          groupId,
        }),
      );
    }
  }, [dispatch, groupId]);

  const deletePackageConfirmationHandler = () => {
    const successHandler = () => {
      setIsDeleteModalOpen(false);
      setDeletePackageId(-1);
      dispatch(getPackagesByGroupId({ groupId }));
    };
    dispatch(
      deletePackageById({
        id: deletePackageId,
        successHandler,
      }),
    );
  };

  return (
    <React.Fragment>
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        onConfirm={deletePackageConfirmationHandler}
        heading="Delete Package"
        text="Are you sure you want to delete this package?"
        loading={deletePackageByIdLoading}
      />
      <Modal
        isOpen={addPackage}
        setIsOpen={setAddPackage}
        showCloseIcon={false}
      >
        <AddPackage
          isOpen={addPackage}
          setIsOpen={setAddPackage}
          groupId={groupId}
        />
      </Modal>
      <Modal
        isOpen={editPackage}
        setIsOpen={setEditPackage}
        showCloseIcon={false}
      >
        <EditPackage
          isOpen={editPackage}
          setIsOpen={setEditPackage}
          groupId={groupId}
          packageData={packageData}
        />
      </Modal>
      <div className={styles.mainContainer}>
        <div className={styles.gridContainer}>
          <AgGridReact
            className={styles.grid}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            onGridReady={onGridReady}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={[5, 10, 20, 50, 100]}
            animateRows={true}
            domLayout="normal"
          />
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={() => setAddPackage(true)}>
            Add Package
          </button>
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.NextButton} onClick={nextHandler}>
            Finish
          </button>
          <button
            className={styles.backButton}
            onClick={() => setActiveTab("amenities")}
          >
            Back
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Packages;
